import store from "../../redux/store";
import { ConsentString } from "consent-string";
import { boundSetUserPurposes, boundSetUserCustomPurposes } from "../../redux/actions/consent";
import { getCookie, checkLocalStorage } from "../cookies";
import checkOldCookie from "../cookies/check_old_cookie";
import { boundSetIsNotInitital } from "../../redux/actions/is_initial";

export let consentData = {};

const setConsentData = () => {
        const cookie = getCookie() || checkLocalStorage();
        const state = store.getState();
        const list = state.vendorList.list;
        
        consentData = new ConsentString(cookie);
        consentData.setGlobalVendorList(list);

        if (checkOldCookie()) { return }
        
        const purposesConsent = consentData.getPurposesAllowed();
        const customConsent = state.customPurposesList.list.purposes.map(e => e.id);

        // use if vendors are implemented
        // const vendorsConsent = consentData.getVendorsAllowed();
        
        boundSetUserPurposes(purposesConsent);
        boundSetUserCustomPurposes(customConsent);

        // sets a flag for custom CB to be executed
        if (cookie) { boundSetIsNotInitital() }
        
        // disable vendors and features, they are not included in the current version
        // boundSetUserFeatures([]); // not implemented yet in the IAB CS SDK-JS
        // boundSetUserVendors(vendorsConsent);
};

export default setConsentData;